import React, { useContext, useState, useEffect } from "react";
import NewBanner from "../common/NewBanner";
import TopProjects from "../project/TopProjects";
import { useDispatch, useSelector } from "react-redux";
import { AppContext } from "../../context/AppContext";
import { fetchProfileProperties } from "../../redux/profilePropertySlice";
import config from "../../config/config";
import AdsBannerSection from "../common/AdsBannerSection ";
import postPropertyBanner from "../../images/Homepage/post-property.png";
import postPropertyBannermob from "../../images/Homepage/post-property-mob.jpg";
import questionMark from "../../images/Homepage/output.gif";
import bhkimg from "../../images/Homepage/HomePrecise.png";
import { Link, useLocation } from "react-router-dom";
import {
  fetchTopProjects,
  fetchPremiumProjects,
  fetchAffordableProjects,
} from "../../redux/homeSlice";
import AffordableProjects from "../project/AffordableProjects";
import ShowcaseAdSection from "../common/ShowcaseAdSection";
import AllLocalitiesMap from "../common/AllLocalitiesMap";
import axios from "axios";
import FeaturedCollection from "../common/FeaturedCollection";
import OfferedFacilities from "./OfferedFacilities";
import RecommendedSellers from "../RecommendedSellers";
import NewRecommendedSellers from "../NewRecommendedSellers";
import NewTestimonial from "../NewTestimonial";
import NewPremiumProjects from "../project/NewPremiumProjects";

const NewHome = () => {
  const location = useLocation();

  // Split path and get the last part
  const category = location.pathname.split("/")[1];
  const { topProjects, premiumProjects, status, error, affordableProjects } =
    useSelector((state) => state.home);
  const [wishlist, setWishlist] = useState([]);
  const { user } = useContext(AppContext);
  const token = config.getAuthToken();
  const [allLocalities, setAllLocalities] = useState([]);
  const [bhkType, setBhkType] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const handleDispatch = () => {
    if (user?.data?.id != null) {
      dispatch(fetchProfileProperties(user?.data?.id));
    }
  };
  useEffect(() => {
    dispatch(fetchTopProjects());
    dispatch(fetchPremiumProjects());
    dispatch(fetchAffordableProjects());
  }, [dispatch]);
  useEffect(() => {
    const fetchAllLocalities = async () => {
      try {
        const response = await axios.get(
          `${
            process.env.REACT_APP_BASE_URL
          }/search/allLocalities?city_id=${1}&service=${"sell"}&type=${[
            "apartment",
          ]}`
        );
        setAllLocalities(response.data?.data || []); // Update suggestions state
        //alert(JSON.stringify(response.data?.data));
        // console.log(response?.data?.data[0]);
      } catch (error) {
        console.error("Error fetching localities:", error);
      }
    };

    const fetchBhkType = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/getBhkTypes`
        );
        if (response.data.status === "success") {
          setBhkType(response.data.data); // Set the property list
          setLoading(false);
        } else {
          setBhkType([]);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setBhkType([]);
        setLoading(false);
      }
    };
    fetchBhkType();
    fetchAllLocalities();
  }, []);
  return (
    <>
      <NewBanner
        category={category == "" || category != "buy" ? "home" : "buy"}
      />
      <TopProjects
        topProjects={topProjects}
        wishlist={wishlist}
        user={user}
        token={token}
        handleDispatch={handleDispatch}
      />
      <NewPremiumProjects
        premiumProjects={premiumProjects}
        user={user}
        token={config.getAuthToken()}
        wishlist={wishlist}
        handleDispatch={handleDispatch}
        category="buy"
      />
      <AffordableProjects
        title={"Explore Our Affordable Projects In Jaipur"}
        affordableProjects={affordableProjects}
        user={user}
        token={config.getAuthToken()}
        wishlist={wishlist}
        handleDispatch={handleDispatch}
        category="buy"  
      />
      <AdsBannerSection />
      {/* Top Localities */}
      {allLocalities?.length > 0 && (
        <AllLocalitiesMap
          allLocalities={allLocalities}
          category={"buy"}
          property_type={"apartment"}
        />
      )}
      <ShowcaseAdSection />
      <FeaturedCollection category="buy" />
      {/* Choose your BHK type */}
      <section className="bhk-section sectiontopgap">
        <div className="container">
          <div className="sectiontitle">
            <div className="titleunderline" data-aos="fade-right">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1>Be Precise And Follow Your Dreams</h1>
            <h5 className="choose_bhk_text">Choose Your BHK Type</h5>
          </div>

          <div className="bhkcover content_margin">
            <div className="row bhkcontainer">
              <div className="col-md-4">
                {/* <img
                  src={bhkimg}
                  alt="DreamSakha"
                  className="img-fluid bhklftimg"
                /> */}
              </div>

              <div className="col-md-8 p-4 text-center">
                {/* <h5>Choose Your BHK Type</h5> */}
                <div className="bhkbox">
                  <div className="bhkrow">
                    {bhkType?.length > 0 &&
                      bhkType?.map((project, index) => (
                        <div className="circle-box" key={index}>
                          <div className="circle outermost"></div>
                          <div className="circle middle"></div>
                          <div className="circle innermost"></div>
                          <div
                            onClick={() => {
                              const onlyBhkNumber = project?.bhk_type
                                ?.replace(/\s+/g, "")
                                .toLowerCase();
                              const bhk =
                                onlyBhkNumber === "5+bhk"
                                  ? "5bhk+"
                                  : onlyBhkNumber;

                              localStorage.setItem(
                                "feature_clicked",
                                `bhk_type:${bhk}`
                              );

                              const url = `/buy/searches/${bhk}s-for-sale-in-jaipur-rajasthan-srcid-1`;
                              window.location.href = url;
                            }}
                          >
                            <div className="circle inner">
                              <h6 className="title">{project?.bhk_type}</h6>
                              <p style={{ color: "black" }}>
                                <span className="properties">
                                  {project?.property_count} +<br />
                                  Properties
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <OfferedFacilities user={user} token={token} />
      <section className="postProperty-section sectiontopgap">
        <Link to="/postProperty">
          <div className="container-fluid">
            <div className="desk">
              <img src={questionMark} className="banner-mark" />
              <img src={postPropertyBanner} className="banner-image" />
            </div>

            <div className="mob">
              <img src={postPropertyBannermob} className="banner-image mt-2" />
            </div>
          </div>
        </Link>
      </section>
      <NewRecommendedSellers />
      <NewTestimonial />
    </>
  );
};

export default NewHome;
